export const messages = {
  en: require('./en.json'),
  fr: require('./fr.json'),
  nl: require('./nl.json'),
}
